import RemoveTeamModal from 'modules/teams/components/RemoveTeamModal'
import TeamModal from 'modules/teams/components/TeamModal'

const DeleteTeamModal = () => <TeamModal modalComponent={RemoveTeamModal} />
export default DeleteTeamModal
